import {CompetitionEvent} from './CompetitionEvent';

export class CompetitionCreated extends CompetitionEvent {}
